export default {
      id: "input__select-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#input__select",
      toString: function () {
        return this.url;
      }
    }